'use client';

import useTranslation from 'next-translate/useTranslation';
import { menu } from '@stereoagency/sanity-schema';
import { Footer as UIFooter } from '@stereoagency/ui';
import { menuItemAsLink, platformFromURL } from '@/utils';

const menuQuery = menu.schema.builder.first().use();

type Props = {
  primaryMenu: (typeof menuQuery)[1] | null;
  secondaryMenu: (typeof menuQuery)[1] | null;
  actionsMenu: (typeof menuQuery)[1] | null;
  moreMenu: (typeof menuQuery)[1] | null;
  socialMenu: (typeof menuQuery)[1] | null;
  legalMenu: (typeof menuQuery)[1] | null;
};

export default function Footer({
  primaryMenu,
  secondaryMenu,
  actionsMenu,
  moreMenu,
  socialMenu,
  legalMenu
}: Props) {
  const { t } = useTranslation('footer');
  const emails = t<string | string[]>('emails', null, {
    returnObjects: true
  });

  return (
    <UIFooter
      className="order-last"
      labels={{
        social: t('labels.social'),
        action: {
          title: t('labels.action.title'),
          description: t('labels.action.description')
        }
      }}
      action={{
        href: 'https://uclouvain.us9.list-manage.com/subscribe?u=bd8e716fdfbb756c9115922a6&id=b6bff2be57',
        target: '_blank',
        label: t('labels.subscribe')
      }}
      content={<div className="whitespace-pre-line">{t('content')}</div>}
      emails={typeof emails === 'string' ? [emails] : emails}
      secondaryAction={
        actionsMenu?.menuItems?.length
          ? menuItemAsLink(actionsMenu.menuItems[0])
          : undefined
      }
      navigationItems={
        primaryMenu?.menuItems?.map((item) => menuItemAsLink(item)) ?? []
      }
      additionalItems={
        secondaryMenu?.menuItems?.map((item) => menuItemAsLink(item)) ?? []
      }
      contentItems={
        moreMenu?.menuItems?.map((item) => menuItemAsLink(item)) ?? []
      }
      socialItems={
        socialMenu?.menuItems?.map((item) => {
          const linkProps = menuItemAsLink(item);
          const platform = platformFromURL(linkProps.href);
          return { ...linkProps, platform };
        }) ?? []
      }
      legalItems={
        legalMenu?.menuItems?.map((item) => menuItemAsLink(item)) ?? []
      }
    />
  );
}
